import React from 'react';

const variants = {
  New: 'bg-blue-100 text-blue-700',
  Assigned: 'bg-yellow-100 text-yellow-700',
  Pending: 'bg-orange-100 text-orange-700',
  Completed: 'bg-green-100 text-green-700',
  Open: 'bg-red-100 text-red-700',
  Declined: 'bg-red-100 text-red-700',
  'In Review': 'bg-purple-100 text-purple-700',
  Active: 'bg-brand-accent text-brand-dark',
  'Timed Out': 'bg-gray-800 text-white shadow-sm',
};

export const Badge = ({ children, status, className = '' }) => {
  const colorClass = variants[status] || 'bg-gray-100 text-gray-700';
  return (
    <span className={`px-3 py-1 rounded-full text-xs font-medium ${colorClass} ${className}`}>
      {children}
    </span>
  );
};